import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AppConfig } from '../../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-jacking-rob-fuel-figures',
  templateUrl: 'jacking-rob-fuel-figures.html',
})
export class JackingRobFuelFiguresPage {
  config = AppConfig.settings;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
  }

}



// WEBPACK FOOTER //
// ./src/pages/DPR Pages/jacking-rob-fuel-figures/jacking-rob-fuel-figures/jacking-rob-fuel-figures.ts